import { z } from 'zod';
// Schema module, not the barrel: the barrel's components would pull auth and the store
// into a non-UI import graph.
import { makeConfigSettingAddSchema } from '@/shared/components/config-settings/configSettingAddSchema';

// Backend forbids '/' in a config key ('/' cannot bind to the /{key} route parameter);
// refined here so the user sees a form error before submit.
export const dealerConfigSettingKeySchema = z
    .string()
    .min(1, 'Key is required')
    .max(255, 'Key must be 255 characters or fewer')
    .refine((v) => !v.includes('/'), { message: 'Key cannot contain "/"' });

export const dealerConfigSettingAddSchema = makeConfigSettingAddSchema({ keySchema: dealerConfigSettingKeySchema });

export type DealerConfigSettingAddInput = z.input<typeof dealerConfigSettingAddSchema>;
export type DealerConfigSettingAddOutput = z.output<typeof dealerConfigSettingAddSchema>;
